import React, { useCallback, useEffect, useState } from 'react';
import { Loader } from '../../../UiKit';
import { EmptyState } from '../../commons';
import ActionOptions from '../ReportIssue/ActionOptions/ActionOptions';
import SuccessScreen from '../ReportIssue/ActionOptions/SuccessScreen';
import { InvalidSearchImg } from '../../../images/images';
import { reasonModel } from '../../../api';

function OrderLevelIssues({
  orderId,
  cartId,
  userId = null,
  complaintType,
  goBack,
  orderLevelPayload = {},
}) {
  const [resolutionSuccessDetails, setResolutionSuccessDetails] =
    useState(null);
  const [resolutionOptionDetails, setResolutionOptionDetails] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMsg] = useState(null);

  const errorHandler = () => {
    setLoading(false);
    setError(true);
    setErrorMsg('Something went wrong');
  };

  useEffect(() => {
    const evaluate = () => {
      const dataForEvaluate = {
        order_id: orderId,
        cart_id: cartId,
        complaint_type: complaintType,
        selected_items: [],
        ...orderLevelPayload,
        is_approved_complaint: false,
      };
      setLoading(true);
      return reasonModel
        .evaluateResolution(dataForEvaluate)
        .then((response) => {
          if (!response) return null;
          if (response && response.isError === true) {
            errorHandler();
          } else {
            setLoading(false);
            setResolutionOptionDetails(response);
          }
          return response;
        })
        .catch((err) => {
          errorHandler();
        });
    };
    evaluate();
  }, [orderId, cartId, complaintType]);

  const resolve = useCallback(
    (resolutionOption) => {
      const selectedItems = [];
      const dataForResolve = {
        resolution: resolutionOption?.resolution,
        sub_resolution: resolutionOption?.sub_resolution || null,
        complaint_id: resolutionOptionDetails?.complaint_id,
        order_id: orderId,
        cart_id: cartId,
        complaint_type: complaintType,
        selected_items: selectedItems,
        ...orderLevelPayload,
      };
      setLoading(true);
      return reasonModel
        .createResolution(dataForResolve)
        .then((response) => {
          if (!response) return null;

          if (response && response.isError === true) {
            errorHandler();
          } else {
            setLoading(false);
            setResolutionSuccessDetails(response);
          }
          return response;
        })
        .catch((err) => {
          errorHandler();
        });
    },
    [orderId, cartId, complaintType, resolutionOptionDetails],
  );

  if (isLoading) return <Loader />;
  if (isError)
    return <EmptyState img={InvalidSearchImg} heading={errorMessage} />;
  return (
    <div className='raiseIssueContainer'>
      {resolutionSuccessDetails ? (
        <SuccessScreen details={resolutionSuccessDetails} goBack={goBack} />
      ) : (
        <div className='raiseIssueContent'>
          <ActionOptions
            resolutionOptionDetails={resolutionOptionDetails}
            resolve={resolve}
            isDisabled={isLoading}
            orderId={orderId}
            cartId={cartId}
            userId={userId}
            complaintType={complaintType}
          />
        </div>
      )}
    </div>
  );
}

export default OrderLevelIssues;
